import PropTypes from 'prop-types';
import React from 'react';

// Components.
import FormSubmit from './formSubmit';
import NewsletterItem from './newsletterItem';

// Config.
import { FORM_VALUES_SHAPE, GROUP_SHAPE } from '../config/proptypes';

const CustomForm = ({
  errors,
  formValues,
  groups,
  loading,
  onFormSubmit,
  onInputChange,
  onListSelect,
  selectedLists,
  status,
}) => (
  <form onSubmit={onFormSubmit}>
    {groups.map((group) => (
      <section key={group.label} className="newsletters__section">
        <h2 className="newsletters__section-label">
          {group.label}
        </h2>
        <div className="newsletters__section-items">
          {group.items.map((newsletter) => (
            <NewsletterItem
              key={newsletter.slug}
              newsletter={newsletter}
              onChange={onListSelect}
              selectedLists={selectedLists}
            />
          ))}
        </div>
      </section>
    ))}
    <FormSubmit
      errors={errors}
      formValues={formValues}
      loading={loading}
      onFormSubmit={onFormSubmit}
      onInputChange={onInputChange}
      selectedLists={selectedLists}
      status={status}
    />
  </form>
);

CustomForm.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  formValues: PropTypes.shape(FORM_VALUES_SHAPE).isRequired,
  groups: PropTypes.arrayOf(PropTypes.shape(GROUP_SHAPE)).isRequired,
  loading: PropTypes.bool.isRequired,
  onFormSubmit: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onListSelect: PropTypes.func.isRequired,
  selectedLists: PropTypes.arrayOf(PropTypes.string).isRequired,
  status: PropTypes.string.isRequired,
};

export default CustomForm;
